import { supabase } from "@/integrations/supabase/client";

export const createPromotionCode = async (couponId: string, code: string) => {
  try {
    const { data, error } = await supabase.functions.invoke('create-promotion-code', {
      body: { coupon_id: couponId, code: code }
    });

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error creating promotion code:', error);
    throw error;
  }
};

// One-time seed for DOWDGROUP202588 (guarded)
if (typeof window !== 'undefined' && !localStorage.getItem('promo_seeded_202588')) {
  createPromotionCode('fEVKLsRW', 'DOWDGROUP202588')
    .then(() => localStorage.setItem('promo_seeded_202588', '1'))
    .catch(() => {/* ignore if already exists */});
}
